import { assertStatusCode, createRestClient } from '../restClient';

const client = createRestClient('', '');

interface Body {
    // eslint-disable-next-line camelcase
    nordic_origin: string;
}

export const get = (url: string) =>
    client
        .get(url)
        .then(assertStatusCode([200]))
        .then(response => response.json());

export const put = (url: string, data: Body) =>
    client.put(url, undefined, data).then(response => {
        assertStatusCode([200, 204])(response);
    });
